(function($) {
    let animateElement = $('.js-animate');
    let animateIntroElement = $('.js-animate-intro');

    // adds animated class to each .animate element on page load
    animateElement.each(function() {
        $this = $(this);
        var dataAnimation = $this.attr('data-animation');
        var dataAnimationDelay = $this.attr('data-animation-delay');

        $this
            .addClass('is-animated')
            .addClass(dataAnimation)
            .css('animation-delay', dataAnimationDelay)
    });

    // adds animated setup for intro block
    setTimeout(function() {
        animateIntroElement.each(function() {
            $(this)
                .addClass('is-animated')
        });
    }, 600);

}(jQuery));
